import React from 'react';
import { Box, Typography } from '@mui/material';
import { statPillBox } from '../styles';

type Props = {
  label: string;
  value: number;
  color?: string;
};

const StatPill: React.FC<Props> = ({ label, value, color }) => (
  <Box sx={statPillBox}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="h6" fontWeight={700} color={color ?? 'text.primary'}>
      {value}
    </Typography>
  </Box>
);

export { StatPill };
